import 'hammerjs';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/root/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}


const color =
  (environment.isMultiColorActive || environment.isDarkSwitchActive) &&
  localStorage.getItem(environment.themeColorStorageKey)
    ? localStorage.getItem(environment.themeColorStorageKey)
    : environment.defaultColor;


/*
 * JWEDIT:
 *
 * Load Google Maps dynamically so Angular uses:
 *
 * environment.ts
 *      when running locally with ng serve
 *
 * environment.prod.ts
 *      when building production for Azure
 *
 */
function loadGoogleMaps(): Promise<void> {

  return new Promise((resolve, reject) => {

    // Google Maps has already been loaded.
    if ((window as any).google?.maps) {
      resolve();
      return;
    }


    // Prevent accidentally loading Google Maps more than once.
    const existingScript =
      document.querySelector('script[data-google-maps-api]');

    if (existingScript) {

      existingScript.addEventListener('load', () => resolve());

      existingScript.addEventListener('error', () =>
        reject(new Error('Google Maps API failed to load'))
      );

      return;
    }


    const script = document.createElement('script');

    script.setAttribute('data-google-maps-api', 'true');

    script.src =
      'https://maps.googleapis.com/maps/api/js' +
      '?key=' + encodeURIComponent(environment.googleMapsApiKey) +
      '&libraries=geometry,places';

    script.async = true;
    script.defer = true;


    script.onload = () => {
      console.log(
        environment.production
          ? 'Google Maps loaded using PRODUCTION configuration'
          : 'Google Maps loaded using DEVELOPMENT configuration'
      );

      resolve();
    };


    script.onerror = () => {
      reject(
        new Error('Unable to load Google Maps JavaScript API')
      );
    };


    document.head.appendChild(script);

  });

}


/*
 * Load the selected Vien theme first.
 */
import('./assets/css/sass/themes/vien.' + color + '.scss')

  .then(() => {

    localStorage.setItem(
      environment.themeColorStorageKey,
      color
    );


    /*
     * Load Google Maps using the API key from the
     * currently selected Angular environment.
     */
    return loadGoogleMaps();

  })

  .then(() => {

    /*
     * Google Maps is now available.
     *
     * Start Angular.
     */
    return platformBrowserDynamic()
      .bootstrapModule(AppModule);

  })

  .catch(err => {

    console.error(
      'Application startup error:',
      err
    );

  });